import * as React from 'react';
import Dropoff from './Dropoff';

const EditDropoff = (props: any) => {
  return <Dropoff isEdit={true} {...props} />;
};

export default EditDropoff;